<template>
  <v-card
    height="100%"
  >
    <v-card-title class="pl-6 pt-4 font-weight-light">
      {{ topTenTitle }}
    </v-card-title>
    <div style="max-width:480px">
      <apexchart
        type="donut"
        :options="chartOptions"
        :series="pieSeries"
      />
    </div>
  </v-card>
</template>

<script>
  import moment from 'moment'
  import { findMonthlyTopTen } from '@/api/PouchDaoReport'
  import { mapGetters } from 'vuex'
  import store from '@/store'
  import { appConfig } from '@/appConfig'

  export default {
    name: 'UsageVoiceTopTenPieChart',
    props: {
      dataCategory: { // get DOMESTIC VOICE or DOMESTIC
        type: String,
      },
      dataType: { // get DOMESTIC VOICE or DOMESTIC
        type: String,
      },
      dataYearMonth: {
        type: Number,
      },
    },
    computed: {
      ...mapGetters('app', {
        customerInfo: 'customerInfo',
        snCount: 'snCount', //, ...
      }),
      ...mapGetters('usage', {
        domesticVoiceCategory: 'domesticVoiceCategory',
        refreshRequired: 'refreshRequired',
      }),
      yearMonthSelectList () {
        const yearMonthList = []
        this.customerInfo.yearMonthSelectList.forEach(yearMonthItem => {
          yearMonthList.push(yearMonthItem.label)
        })
        return yearMonthList
      },
      topTenTitle () {
        if (this.domesticVoiceCategory.dataType === 'CALL') {
          return 'Top Ten Voice Call'
        }
        if (this.domesticVoiceCategory.dataType === 'DURATION') {
          return 'Top Ten Voice Duration'
        }
        if (this.domesticVoiceCategory.dataType === 'SMS') {
          return 'Top Ten National SMS'
        }
        return '12 months total'
      },
    },
    data () {
      return {
        selectedMonth: {},
        // yearMonthList: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        refreshData: true,
        chartOptions: {
          chart: {
            events: {
              dataPointSelection: (e, chart, opts) => {
                // you can call Vue methods now as "this" will point to the Vue instance when you use ES6 arrow function
                this.topTenPointSelected(opts)
              },
            },
          },
          plotOptions: {
            pie: {
              customScale: 0.9,
              expandOnClick: false,
              donut: {
                size: '60%',
                labels: {
                  show: true,
                },
              },
            },
          },
          noData: {
            text: 'No data',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: '#BEC932',
              fontSize: '12px',
              fontFamily: undefined,
            },
          },
          dataLabels: {
            enabled: true,
          },
          tooltip: {
            enabled: false,
          },
          legend: {
            show: true,
            horizontalAlign: 'left',
            offsetX: -30,
            offsetY: 0,
          },
          states: {
            normal: {
              filter: {
                type: 'none',
                value: 0,
              }
            },
            hover: {
              filter: {
                type: 'lighten',
                value: 0,
              }
            },
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: 'none',
                value: 0,
              }
            },
          },
          colors: appConfig.colors,
          fill: {
            type: 'gradient',
          },
        },
      }
    },
    watch: {
      domesticVoiceCategory: {
        handler () {
          console.log('domesticVoiceCategory changed to ', this.domesticVoiceCategory)
          this.switchTopTen(this.domesticVoiceCategory)
        },
      },
      dataYearMonth: {
        handler () {
          console.log('watching dataYearMonth changed to ' + this.dataYearMonth)
          this.refreshFromSelectedYearMonth(this.dataYearMonth)
        },
      },
    },
    mounted () {
      if (this.refreshData) {
        this.selectedMonth = this.customerInfo.latest
        this.switchTopTen(this.dataCategory)
        this.refreshData = false
        console.log('mounted top ten dataCategory ' + this.dataCategory + ' dataType ' + this.dataType)
      }
    },
    methods: {
      topTenPointSelected (opts) {
        console.log(' label ' + this.chartOptions.labels[opts.dataPointIndex] + ' value ' + this.pieSeries[opts.dataPointIndex])
        store.dispatch('usage/updateSnFilter', { sn: this.chartOptions.labels[opts.dataPointIndex] })
        // store.dispatch('usage/updateEquipmentTableFilter', {category: this.dataCategory, label: this.chartOptions.labels[opts.dataPointIndex]})
      },
      switchTopTen (voiceCategory) {
        console.log('switchTopTen ' + voiceCategory + ' calling refreshData')
        this.refreshTopTen(voiceCategory, this.customerInfo.latest)
      },
      refreshFromSelectedYearMonth (yearMonth) {
        console.log('refreshFromSelectedYearMonth ' + yearMonth)
        this.refreshTopTen(this.dataCategory, yearMonth)
      },
      refreshTopTen (voiceCategory, yearMonth) {
        console.log('findMonthlyTopTen voice category ' + this.dataCategory + ' voice datatype ' + this.dataType + ' started', voiceCategory)
        findMonthlyTopTen(this.dataCategory, this.dataType, yearMonth).then(result => {
          console.log('findMonthlyTopTen ' + voiceCategory + ' ' + this.dataType + ' completed')
          const chartData = []
          const labels = []
          result.forEach(pieData => {
            labels.push(pieData.sn + '')
            chartData.push(pieData.qty)
          })
          this.pieSeries = chartData // copy the array...
          this.chartOptions = {
            labels: labels,
          }
        })
      },
    },

  }
</script>

<style scoped>

</style>
